export default "__VITE_ASSET__e719aebe__"